import React from 'react';
import { handleActionError } from '../../../utils/engineering-tools';
import { TimkenUnit } from '../../../../components/bearing-search/types/types';

export type RelubricateByPartNumberState = {
	unit: TimkenUnit;
};

export const initialRelubricateByPartNumberState: RelubricateByPartNumberState = {
	unit: 'M',
};

export type RelubricateByPartNumberAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'reset'; payload?: RelubricateByPartNumberState };

const greaseRelubricateByPartReducer: React.Reducer<
	RelubricateByPartNumberState,
	RelubricateByPartNumberAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				unit: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialRelubricateByPartNumberState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default greaseRelubricateByPartReducer;
